import React, { useEffect, useState } from "react";
import { useIntl } from 'react-intl'
import { Button, Input, Upload, message } from 'antd'
import styles from './Order/index.module.scss'
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons'
import orderApi from "@/api/orderApi";
import group7Png from '../../assets/img/Group7.png'

const Poster: React.FC<any> = (props) => {
  const intl = useIntl()

  const [posterData, setPosterData] = useState<any>({})
  const [initposterData, setInitposterData] = useState<any>({})
  const [voucherLoading, setVoucherLoading] = useState<boolean>(false)
  const [submitLoading, setSubmitLoading] = useState<boolean>(false)
  const [edit, setEdit] = useState<boolean>(false)

  useEffect(() => {
    getPosterData()
  },[])

  useEffect(() => {
    if(edit) {
      setPosterData({...initposterData})
    }
  },[edit])

  const getPosterData = () => {
    orderApi.getPosterData().then((res: any) => {
      if(res.code === 1) {
        setInitposterData(res.data)
        setPosterData({...res.data})
      }
    })
  }
  const submit = () => {
    let params = {
      ...posterData
    }
    setSubmitLoading(true)
    orderApi.updatePosterData(params).then((res: any) => {
      setSubmitLoading(false)
      if(res.code === 1) {
        getPosterData()
        setEdit(false)
        message.success(intl.formatMessage({ id: '修改成功' }))
      }
    })
  }

  const beforeVoucher = (file: any) => {
	  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
	  if (!isJpgOrPng) {
	    message.error(intl.formatMessage({ id: '你可以上传JPG/PNG文件!' }));
	  }
	  const isLt2M = file.size / 1024 / 1024 < 2;
	  if (!isLt2M) {
	    message.error(intl.formatMessage({ id: '上传图片大小必须小于2MB!' }));
	  }
	  return isJpgOrPng && isLt2M;
	}

  const voucher = ({file}: any) => {
    if(file.status === 'uploading') {
      setVoucherLoading(true)
    }
    if(file.status === 'done') {
      setVoucherLoading(false)
      let res = file.response
      if(res.code === 1) {
        let data = file.response.data.files
        let key = Object.keys(data)[0]
        let url = data[key].url
        setPosterData({...posterData, qr_code: url})
      }
    }
  }
  
  return (
    <div className="flex-s-c p10">
      <div className="mr10" style={{ border: '1px solid #f6f6f6' }} >
        <img style={{ width: 260 }} src={group7Png} />
        <div className="flex-b-c p10" style={{ borderTop: '1px dashed #f6f6f6' }}>
          <div className="flex-1">
            <div style={{ fontSize: 16 }}>
              {initposterData.company}
            </div>
            <div className="flex-s-c mt10 mb5" style={{ color: '#FF1A53', fontSize: 20 }}>
              <i className="iconfont icon-a-24gf-telephone1 mr5" />
              {initposterData.phone}
            </div>
            <div className="flex-s-c">
              <i className="iconfont icon-dizhiguanli mr5" />
              {initposterData.address}
            </div>
          </div>
          {
            initposterData.qr_code ? (
              <img
                style={{ width: 80, height: 80, border: '1px solid #f6f6f6' }}
                src={initposterData.qr_code}
              />
            ): null
          }
          
        </div>
      </div>
      <div style={{ background: '#fff', border: '1px solid #E0E0E0', borderRadius: 4 }}>
        <div className="flex-b-c ptb10 plr10" style={{ background: '#F0F0F0' }}>
          <span>{intl.formatMessage({ id: '海报管理' })}</span>
          {
            edit ? (
              <span className="flex-s-c">
                <Button onClick={() => setEdit(false)} className="mr5" size="small">{intl.formatMessage({ id: '取消' })}</Button>
                <Button loading={submitLoading} size="small" onClick={() => submit()}>{intl.formatMessage({ id: '确定' })}</Button>
              </span>
            ): (
              <span style={{ color: '#096bed' }} className="flex-s-c pointer" onClick={() => setEdit(true)}>
                <i  className="iconfont icon-bianji3" />
                {intl.formatMessage({ id: '编辑' })}
              </span>
            )
          }
          
        </div>
        {
          edit ? (
            <div className="p10" style={{ width: 360 }}>
              <div className="flex-s-c">
                <label style={{ width: 120 }}>{intl.formatMessage({ id: '公司名称' })}</label>
                <Input value={posterData.company} onChange={(e: any) => setPosterData({...posterData, company: e.target.value})} style={{ flex: 1 }} placeholder={intl.formatMessage({ id: '公司名称' })}  />
              </div>
              <div className="flex-s-c mt10">
                <label style={{ width: 120 }}>{intl.formatMessage({ id: '联系方式' })}</label>
                <Input value={posterData.phone} onChange={(e: any) => setPosterData({...posterData, phone: e.target.value})} style={{ flex: 1 }} placeholder={intl.formatMessage({ id: '联系方式' })}  />
              </div>
              <div className="flex-s-c mt10">
                <label style={{ width: 120 }}>{intl.formatMessage({ id: '联系地址' })}</label>
                <Input value={posterData.address} onChange={(e: any) => setPosterData({...posterData, address: e.target.value})} style={{ flex: 1 }} placeholder={intl.formatMessage({ id: '联系地址' })}  />
              </div>
              <div className="flex-s-c mt10">
                <label style={{ width: 120 }}>{intl.formatMessage({ id: '二维码' })}</label>
                <div className={styles['voucher']}>
                  <Upload
                    name="files"
                    accept=".png, .jpg, .jpeg, .gif"
                    beforeUpload={beforeVoucher}
                    action="/v1/api/common/file/upload"
                    showUploadList={false}
                    onChange={voucher}
                    disabled={posterData.qr_code}
                  >
                    <div className={styles['upload-area']}>
                      {voucherLoading ? <LoadingOutlined rev={undefined} /> : <PlusOutlined rev={undefined} />}
                      <div style={{ marginTop: 8, color: '#86909C' }}>{intl.formatMessage({ id: '上传' })}</div>
                    </div>
                  </Upload>
                  {
                    posterData.qr_code ? (
                      <div className={styles['img-item']+ ' mr10'} key={posterData.qr_code}>
                        <img src={posterData.qr_code} alt="" />
                        <i className="iconfont icon-quxiao1" onClick={() => setPosterData({...posterData, qr_code: ''})} />
                      </div>
                    ): null
                  }
                </div>
              </div>
            </div>
          ): (
            <div className="p10" style={{ width: 360 }}>
              <div className="flex-s-c">
                <label style={{ width: 120 }}>{intl.formatMessage({ id: '公司名称' })}</label>
                {initposterData.company}
              </div>
              <div className="flex-s-c mt10">
                <label style={{ width: 120 }}>{intl.formatMessage({ id: '联系方式' })}</label>
                {initposterData.phone}
              </div>
              <div className="flex-s-c mt10">
                <label style={{ width: 120 }}>{intl.formatMessage({ id: '联系地址' })}</label>
                {initposterData.address}
              </div>
              <div className="flex-s-c mt10">
                <label style={{ width: 120 }}>{intl.formatMessage({ id: '二维码' })}</label>
                <div className={styles['voucher']}>
                  {
                    initposterData.qr_code ? (
                      <div className={styles['img-item']+ ' mr10'} key={initposterData.qr_code}>
                        <img src={initposterData.qr_code} alt="" />
                      </div>
                    ): null
                  }
                </div>
              </div>
            </div>
          )
        }
        
      </div>
    </div>
  )
}

export default Poster